import { SkeletonBox, SkeletonText, SkeletonCircle } from '../primitives';
import '../primitives/Skeletons.css';

const NavBarSkeleton = () => (
  <div className="skeleton-navbar">
    <SkeletonCircle size={32} />
    <SkeletonText widths={['80px']} lineHeight="20px" />
  </div>
);

const SettingsSkeleton = () => {
  return (
    <div aria-hidden="true">
      <NavBarSkeleton />
      <div className="skeleton-settings">
        <div className="skeleton-settings__grid">
          {/* Plan card */}
          <div className="skeleton-settings__card">
            <div className="skeleton-settings__card-header">
              <SkeletonText widths={['60px']} lineHeight="12px" />
              <SkeletonText widths={['100px']} lineHeight="24px" style={{ marginTop: '8px' }} />
              <SkeletonText widths={['150px']} lineHeight="14px" style={{ marginTop: '4px' }} />
            </div>
            <div className="skeleton-settings__field">
              <SkeletonBox height={44} borderRadius="var(--radius-md)" />
            </div>
            <SkeletonBox width={120} height={40} borderRadius="var(--radius-md)" style={{ marginTop: 'var(--space-md)' }} />
          </div>

          {/* Language card */}
          <div className="skeleton-settings__card">
            <div className="skeleton-settings__card-header">
              <SkeletonText widths={['60px']} lineHeight="12px" />
              <SkeletonText widths={['80px']} lineHeight="24px" style={{ marginTop: '8px' }} />
              <SkeletonText widths={['200px']} lineHeight="14px" style={{ marginTop: '4px' }} />
            </div>
            <div className="skeleton-settings__field">
              <SkeletonBox height={44} borderRadius="var(--radius-md)" />
            </div>
          </div>

          {/* Theme card */}
          <div className="skeleton-settings__card">
            <div className="skeleton-settings__card-header">
              <SkeletonText widths={['60px']} lineHeight="12px" />
              <SkeletonText widths={['60px']} lineHeight="24px" style={{ marginTop: '8px' }} />
              <SkeletonText widths={['180px']} lineHeight="14px" style={{ marginTop: '4px' }} />
            </div>
            <div className="skeleton-settings__field">
              <SkeletonBox height={44} borderRadius="var(--radius-md)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsSkeleton;
